import type { MetalSpecListItemLoc } from "@/modules/metal/metalSpecQuery.ts";

export function getSpecsForLocation<TSpec extends MetalSpecListItemLoc>(specs: TSpec[], locationSlug: string): TSpec[] {
    return specs.filter((p) => p.location === locationSlug);
}
